import { useTranslation } from 'react-i18next';
import TextField from 'components/forms/textField/TextField';

const TriggerAddEditModalNameField = () => {
  const { t } = useTranslation();

  return (
    <TextField
      colSmInput={12}
      label={t('pageAutomations.triggers.modal.name')}
      labelOnTop
      name="name"
      placeholder={t('pageAutomations.triggers.modal.name')}
      required
    />
  );
};

export default TriggerAddEditModalNameField;
